<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>AB = BC = CD = DA | AC ⊥ BD$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(150, 60)">
            <path d="M 60 0 L 210 0 L 150 120 L 0 120 Z" fill="rgba(0, 210, 255, 0.15)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Diagonals (Vertical & Horizontal) -->
            <line x1="60" y1="0" x2="150" y2="120" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />
            <line x1="210" y1="0" x2="0" y2="120" stroke="rgba(255,255,255,0.2)" stroke-dasharray="4" />
            
            <!-- Right angle at center -->
            <rect x="100" y="55" width="10" height="10" fill="none" stroke="#ffd700" stroke-width="1" transform="rotate(25, 105, 60)" />

            <!-- Edge markers (Equal) -->
            <line x1="130" y1="-5" x2="140" y2="5" stroke="#ffd700" stroke-width="2" transform="translate(0, 0)" />
            <line x1="70" y1="115" x2="80" y2="125" stroke="#ffd700" stroke-width="2" transform="translate(0, 0)" />
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>菱形性质：</strong>有一组邻边相等的平行四边形。四条边都相等，两组对边平行。对角线互相垂直平分，且每一条对角线平分一组对角。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RhombusViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>